<h2 mat-dialog-title>{{ 'GeneralMeeting.EditDialogTitle' | translate }}</h2>
<mat-dialog-content>
    @if (!isLoading) {
        <form [formGroup]="formGroup" class="gm-settings-form-container">
            <div class="d-flex align-items-center">
                <sl-input [control]="formGroup.controls.number" type="number" placeholderKey="GeneralMeeting.Number" class="flex-grow-1" />
                <mat-checkbox [formControl]="formGroup.controls.isOrdinary" class="ml-4">
                    {{ 'GeneralMeeting.OrdinaryAnnualMeeting' | translate }}
                </mat-checkbox>
            </div>
            <sl-input [control]="formGroup.controls.title" placeholderKey="General.Title" />
            <sl-textarea [control]="formGroup.controls.place" placeholderKey="GeneralMeeting.Place" [heightRows]="3" />
            <sl-input [control]="formGroup.controls.companyName" placeholderKey="GeneralMeeting.CompanyName" />
            <sl-datetime-input [control]="formGroup.controls.startDateTime" placeholderKey="GeneralMeeting.Start" />
            <sl-datetime-input [control]="formGroup.controls.doorOpening" placeholderKey="GeneralMeeting.DoorOpening" />
            <sl-datepicker
                [control]="formGroup.controls.admissionCardsSendingDate"
                placeholderKey="GeneralMeeting.AdmissionCardsSendingDate"
                class="mt-2" />
            <sl-datetime-input [control]="formGroup.controls.inviteNewByDate" placeholderKey="GeneralMeeting.InviteNewByDate" />
            <sl-datetime-input [control]="formGroup.controls.transactionsByDate" placeholderKey="GeneralMeeting.TransactionsByDate" />
            <sl-datetime-input [control]="formGroup.controls.webInstructionsToDate" placeholderKey="GeneralMeeting.WebInstructionsToDate" />
            <sl-input
                [control]="formGroup.controls.numberOfCoupons"
                type="number"
                [minValue]="0"
                [maxValue]="48"
                placeholderKey="GeneralMeeting.NumberOfCoupons"
                class="mt-2" />
            <div class="d-flex">
                <sl-input
                    [control]="formGroup.controls.maxVotesPerShareholder"
                    type="number"
                    [minValue]="0"
                    placeholderKey="GeneralMeeting.MaxVotesPerShareholder"
                    class="flex-grow-1" />
                <sl-input
                    [control]="formGroup.controls.maxCapitalPerShareholder"
                    type="number"
                    [minValue]="0"
                    placeholderKey="GeneralMeeting.MaxCapitalPerShareholder"
                    class="flex-grow-1 ml-4" />
            </div>
            <sl-input
                [control]="formGroup.controls.totalSharesWithVotingRights"
                type="number"
                [minValue]="0"
                placeholderKey="GeneralMeeting.TotalSharesWithVotingRights" />
            <sl-auto-complete
                placeholderKey="GeneralMeeting.Status"
                [control]="formGroup.controls.gmStatusId"
                [observable]="metaResource.getGmStatuses()" />
            <mat-checkbox [formControl]="formGroup.controls.dmiVote">
                {{ 'GeneralMeeting.DmiVote' | translate }}
            </mat-checkbox>
            <mat-checkbox [formControl]="formGroup.controls.splitInstructions">
                {{ 'GeneralMeeting.SplitInstructions' | translate }}
            </mat-checkbox>
            <mat-checkbox [formControl]="formGroup.controls.complexInstructions">
                {{ 'GeneralMeeting.ComplexInstructions' | translate }}
            </mat-checkbox>
        </form>
    } @else {
        <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <mat-spinner [diameter]="32" />
        </div>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{ 'General.Cancel' | translate }}</button>
    <button mat-button (click)="save()" color="primary" [disabled]="isLoading">{{ 'General.Save' | translate }}</button>
</mat-dialog-actions>
